export default function () {
  const location = window.location;
  const base = `${location.protocol}//${location.hostname}`;

  return location.port ? `${base}:${location.port}` : base;
}
